import _cloneDeep from 'lodash-es/cloneDeep';
import _toUpper from 'lodash-es/toUpper';
import _isString from 'lodash-es/isString';
import _set from 'lodash-es/set';
import _toString from 'lodash-es/toString';
import _find from 'lodash-es/find';
import _reverse from 'lodash-es/reverse';
import _split from 'lodash-es/split';
import _get from 'lodash-es/get';
import _join from 'lodash-es/join';
import _toNumber from 'lodash-es/toNumber';

import { Yii } from "libraries/interfaces/Yii";

import { EventEmitter, Input, OnInit, Output, Directive } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

import * as g from '../forms/utils/groups/index';
// Actions
import { Actions } from '../forms/utils/actions/index';

/**
 * Contract type Config
 * This is the config contrat specific to fieldset
 */
export interface TConfig {
    add: boolean;
    title: string;
    direction: string;
    roomsCount: number;
    quantity: number;
    context: string;
    adult: number;
    child: number;
    infant: number;
    night?: number;
    showMap?: boolean;
    hasTraveller?: boolean;
    hasRoom?: boolean;
    disableDates?: boolean;
}

/**
 * Contract Generic fieldset
 * @deprecated
 */
export interface IGenericFieldset {
    group: FormArray;
    controlName: string;
    context: string;
    config: any;
    disableDates?: boolean;
}

/**
 * Contract Generic fieldset
 */
export interface ISelectOption {
    label: string;
    value: string|number|object;
}

/**
 * GenericForm: Shared variables and functions form
 * @deprecated
 */
@Directive()
export abstract class GenericFieldset implements OnInit {
    /** Set Yii to variable */
    public Yii = Yii;

    // Get all actions
    public actions = Actions;

    /** Must have { action } */
    @Output()
    public notify: EventEmitter<any> = new EventEmitter();

    /** Group as to be FormArray */
    @Input()
    public group: FormArray;

    @Input()
    public fieldsetData: any;

    @Input()
    public repartition: FormGroup;

    @Input()
    public formSubmitted: boolean = false;

    /** FormControlName */
    @Input()
    public controlName: string;

    /** options for dropdown */
    @Input()
    public options: any;

    /** options for dropdown */
    @Input()
    public styleMode: string = 'default';

    /** to replicate the fieldset */
    @Input()
    public nbItems: number;

    /** Config */
    @Input('config')
    public config: TConfig;

    /** for rooming errors */
    @Input()
    public roomingError: any = {};

    /** osman alert form */
    @Output()
    public searchCarrierInfo: EventEmitter<any> = new EventEmitter();

    /**
     * Readonly context can't be modified. Define the context of the fieldset in the inherited class
     * Can't have default value in the generic class
     */
    public abstract readonly context: string;

    /** used to stock nb of Travellers */
    private readonly idList: any = {};

    /** DI - Formbuilder */
    constructor(public fb: FormBuilder) {
    }

    public init() {
        //
    }

    public ngOnInit() {
        //inject data in fields if data provided in @Input fieldsetData
        //overwrite in extended if you need to be more precise
        if (this.fieldsetData) {
            const fieldsetData = _cloneDeep(this.fieldsetData);
            const control = this.group;
            control.patchValue(fieldsetData);
        }

        this.init();
    }

    /**
     * addFields add fields to form
     * @param form : FormGroup
     * @param ctrl : is the name of the fieldset
     */
    public addFields(context?: string): void {
        const control = this.group;
        const fn = context ? context : this.context + 'GroupInArray';
        control.push((g as any)[fn](this.fb));
    }

    /**
     * addFields add fields to form
     * @param form : FormGroup
     * @param ctrl : is the name of the fieldset
     */
    public addFieldsAfter(_index: number, context?: string): void {
        const control = this.group;
        const fn = context ? context : this.context + 'GroupInArray';
        control.insert(_index + 1, (g as any)[fn](this.fb));

    }

    public addFieldsBefore(_index: number, context?: string): void {
        const control = this.group;
        const fn = context ? context : this.context + 'GroupInArray';
        control.insert(_index, (g as any)[fn](this.fb));

    }

    /**
     * addFields add fields to form
     *
     * @param {number} _nb
     * @param _data
     * @param {boolean} _increment
     */
    public addNbFields(_nb: number, _data: any, _increment: boolean = false): void {
        const control = this.group;
        const nbControl = control.length;

        for (let i = 0; i < _nb; i++) {
            this.addFields();
            if (_data) {
                this.patchValue(i + nbControl, _data, _increment);
            }
        }
    }

    /**
     * removeFields remove fields from form
     * @param form : FormGroup
     * @param ctrl : is the name of the fieldset
     * @param i : is the numero of the fieldset
     */
    public removeField(i: number): void {
        const control = this.group;
        control.removeAt(i);
    }

    /**
     * firstField remove all fields, except the first One
     * @param form : FormGroup
     * @param ctrl : is the name of the fieldset
     * @param i : is the numero of the fieldset
     */
    public firstField(): void {
        const control = this.group;
        const nbControl = control.length;

        if (nbControl > 1) {
            for (let i = nbControl - 1; i > 0; i--) {
                control.removeAt(i);
            }
        }
    }




    /**
     * transform content in MAJ. has to be put on (blur) (maybe change?)
     * @param _ctrl : the fieldset
     * @param _path : value to set
     * @param _event : original event
     */
    public upperCase(_ctrl: any, _path: string, _event: any): void {
        const ctrl = _ctrl.get(_path);
        const value = ctrl.value;
        if (_isString(value)) {
            ctrl.setValue(_toUpper(value));
        }
    }

    /**
     * patch a value depending of position
     * @param fieldset : the fieldset
     * @param i : is the numero of the fieldset to reset
     */
    public patchValue(_i: number, _data: any, _increment: boolean): void {
        const nb = _i + 1;

        let value: string;
        if (_increment) {
            value = _data.value + nb;
        } else {
            value = _data.value;
        }

        const GROUP = this.group;

        const fieldset = GROUP.get(_toString(_i));


        const valueF = fieldset.get(_data.path);

        valueF.patchValue(value);

        _set(this.idList, _i, value);
    }


    public restrictNumeric(_path: string, _min: number, _max?: number) {

        const GROUP = this.group;

        const ctrl = GROUP.get(_path);

        const value = ctrl.value;

        if (_toNumber(value) < _min || isNaN(_toNumber(value))) {

            ctrl.patchValue(_min);
        }
        else if (_max && _toNumber(value) > _max) {

            ctrl.patchValue(_max);

        }
    }

    public getContent(_ctrl: any): any {
        if (_ctrl) {
            return _ctrl.value;
        }
    }

    /**
     * Check with 'path' is touched && has Error
     * @param {string} _path : path to the field
     * @param {string} _errorName : error to catch
     * @returns {boolean}
     */
    public hasError(_path: string | any[], _errorName: string): boolean {
        if (this.formSubmitted) {
            return this.group.get(_path).hasError(_errorName);
        } else {
            return this.group.get(_path).touched && this.group.get(_path).hasError(_errorName);

        }
    }

    /**
     * get the value of of ctrl in a group
     * @param _group
     * @param {string} _ctrl
     * @returns {any}
     */
    public getValue(_group: any, _ctrl: string): any {
        const value = _group.get(_ctrl).value;
        return value;
    }

    /**
     * check if a value is present in an array
     * @param _group
     * @param {string} _ctrl
     * @param _value
     * @returns {any}
     */
    public hasValue(_group: any, _ctrl: string, _value: any): boolean {
        const value = _group.get(_ctrl).value;

        if (_find(value, (o: any) => {
            return o === _value;
        })) {
            return true;
        } else {
            return false;
        }

    }


    public isValid(_path) {
        const form = this.group.root;
        const errors = form.errors;

        if (_get(errors, _path)) {
            return false;
        }
        return true;
    }

    /**
     * date Reverse ; '2008-02-23' et '23-02-2008'
     * @param {string} _date
     */
    protected dateReverse(_date: string) {
        if (_isString(_date)) {
            let dateArray = _split(_date, '-');
            if (dateArray.length === 3) {
                dateArray = _reverse(dateArray);
                _date = _join(dateArray, '/');
            }
            return _date;
        }
        return null;
    }
}
